import { CodeGrant } from "./types";

export enum Roles {
  ADMIN = "Admin",
  BUSINESS = "User",
  VIEWER = "Domain Users",
}

export const operationNameMap: Record<string, CodeGrant> = {
  add: "C",
  read: "R",
  edit: "U",
  delete: "D",
};
